/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Gate_VisitInputs */

const en_landing_gate_visit = /** @type {(inputs: Landing_Gate_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A session`)
};

const pl_landing_gate_visit = /** @type {(inputs: Landing_Gate_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia`)
};

/**
* | output |
* | --- |
* | "A session" |
*
* @param {Landing_Gate_VisitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_gate_visit = /** @type {((inputs?: Landing_Gate_VisitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Gate_VisitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_gate_visit(inputs)
	return en_landing_gate_visit(inputs)
});